import React, { useState, useEffect, useCallback, useMemo } from 'react'
import Card from 'react-bootstrap/esm/Card'
import Controllers from '../../Api/Controllers'
import ReactPlaceholder from 'react-placeholder/lib'
import { FormCustom, Input, SwitchToggle, Select } from '../../Components/Form/Form'
import Button from 'react-bootstrap/Button'
import Helpers from '../../Components/Helpers/Helpers'
import { useParams } from 'react-router-dom'
import Loading from '../../Components/Layout/Styled/Loading'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'

const Cart = _ => {
    const { type } = useParams()
    const history = useHistory()

    const [taxValue, setTaxValue] = useState(0)
    const [shippingFree, setShippingFree] = useState({
        shipping_free: 0,
        shipping_value: 0
    })
    const [showLoading, setShowLoading] = useState(false)

    const [customers, setCustomers] = useState({})
    const [details, setDetails] = useState([])
    const [ready, setReady] = useState(false)
    const [preview, setPreview] = useState(true)
    const [existsStock, setExistsStock] = useState({
        message: '',
        products: []
    })

    const [rowsBranchOffice, setRowsBrachOffice] = useState([])
    const [existsTax, setExistsTax] = useState(false);
    const [taxZipCode, setTaxZipCode] = useState({});
    const [hasTaxByZipCode, setHasTaxByZipCode] = useState(false);
    const [isUSA, setIsUSA] = useState(false);

    const [regimen, setRegimen] = useState([]);
    const [hasInvoice, setHasInvoice] = useState(false);
    const [invoiceData, setInvoiceData] = useState({
        p_rfc_customers: '',
        p_zip_code_customers: '',
        p_id_regimen: '',
        p_id_cfdi: '',
    })
    const [cfdi, setCfdi] = useState([])

    const [discount, setDiscount] = useState({
        status: false,
        discount: 0,
        discount_type: ''
    })

    const [hasSubscription, setHasSubscription] = useState(0)

    const loadAll = async () => {
        const getCartCustomers = await Controllers.cart.get_cart_customers();
        Promise.all([
            Controllers.cart.get_cart_det(),
            Controllers.branch_office.get_branch_office_without_laboratory(),
            Controllers.regimen.get_regimen(),
            Controllers.cfdi.get_cfdi()
        ]).then(([
            resCartDet, resBranchOffice, resRegimen, resCfdi
        ]) => {
            if (getCartCustomers.response === 'success') {
                let customersInfo = getCartCustomers.data

                setRegimen(resRegimen.data)
                setCfdi(resCfdi.data)
                setDetails(resCartDet.data.map(r => {
                    if (customersInfo.discount.status) {
                        r.price_product = parseFloat(r.price_original) - (parseFloat(r.price_original) * parseFloat(customersInfo.discount.discount))
                    }

                    return r
                }))

                setInvoiceData({
                    p_rfc_customers: getCartCustomers.data.rfc_customers,
                    p_zip_code_customers: getCartCustomers.data.zip_code_customers,
                    p_id_regimen: getCartCustomers.data.id_regimen,
                    p_id_cfdi: getCartCustomers.data.id_cfdi,
                })
                setHasInvoice(parseInt(getCartCustomers.data.has_invoice_doc) === 1)

                setCustomers(customersInfo)
                setDiscount(customersInfo.discount)
                setExistsTax(customersInfo.exists_tax_by_zip_code);
                setIsUSA(customersInfo.is_usa);
                if (!customersInfo.exists_tax_by_zip_code) {
                    setPreview(false);
                } else {
                    if (customersInfo.has_tax_by_zip_code) {
                        setHasTaxByZipCode(true);
                        setTaxZipCode(customersInfo.tax_zip_code);
                    }

                    if (parseInt(customersInfo.pick_up_branch_office) === 0) {
                        if (customersInfo.has_tax_by_zip_code) {
                            setTaxValue(parseFloat(customersInfo.tax_zip_code.tax_value))
                        } else {
                            setTaxValue(parseFloat(customersInfo.value_tax))
                        }
                    } else {
                        setTaxValue(parseFloat(customersInfo.value_tax_pick_up))
                    }

                    setShippingFree({
                        shipping_free: parseFloat(customersInfo.shipping_free),
                        shipping_value: parseFloat(customersInfo.shipping_value)
                    })
                }

                setRowsBrachOffice(resBranchOffice.data.filter(b => {
                    if (customersInfo.code_money === 'MXN') {
                        return b.id_type_money === 2
                    }
                    return b.id_type_money === 1
                }))

                setHasSubscription(customersInfo.has_subscription)

                setReady(true)
            }
        })
    }

    useEffect(() => {
        loadAll();
    }, [])

    const getSubtotal = useCallback(() => {
        let total = 0
        let totalWithoutIva = 0
        details.forEach(r => {
            let subt = parseFloat(r.qty_product) * parseFloat(r.price_product)
            if (!isNaN(parseFloat(r.qty_product) * parseFloat(r.price_product))) {
                if (isNaN(parseFloat(r.exempt))) {
                    total += subt
                } else {
                    totalWithoutIva += subt
                }
            }
        })

        let has_shipping = total < shippingFree.shipping_free && parseInt(customers.pick_up_branch_office) === 0
        let shipping = has_shipping ? shippingFree.shipping_value : 0
        total = total + shipping

        let subtotal = parseFloat(total / (1 + taxValue)).toFixed(2)
        let iva = (total - parseFloat(total / (1 + taxValue))).toFixed(2)
        let totalGeneral = (total + totalWithoutIva).toFixed(2)
        let totalIva = total.toFixed(2);

        if (isUSA) {
            subtotal = total;
            totalIva = (subtotal * parseFloat((1 + taxValue))).toFixed(2)
            iva = (parseFloat(totalIva) - parseFloat(subtotal)).toFixed(2);
            totalGeneral = (parseFloat(totalIva) + parseFloat(totalWithoutIva)).toFixed(2);
            subtotal = subtotal.toFixed(2)
        }

        totalWithoutIva = totalWithoutIva.toFixed(2);
        shipping = shipping.toFixed(2)

        /* let discountValue = 0
        if (discount.status) {
            discountValue = (parseFloat(totalGeneral) * parseFloat(discount.discount))
            totalGeneral = (parseFloat(totalGeneral) - discountValue).toFixed(2)
        } */

        return {
            totalIva,
            totalWithoutIva,
            total: totalGeneral,
            discount: 0,
            subtotal,
            iva,
            shipping,
            has_shipping,
            is_usa: isUSA,
            tax_value: taxValue
        }
    }, [details, taxValue, shippingFree, customers, isUSA])

    const dataSubmit = useCallback(() => {
        let dets = []

        details.forEach(d => {
            dets.push({
                p_id_product: d.id_product,
                p_qty: d.qty_product,
                p_price: d.price_product,
                p_price_original: d.price_original,
                p_lot: d.lot_product,
                p_point: d.point_product,
                p_value_business: d.value_business_product,
                p_pack_product: d.pack_product
            })
        })

        return {
            p_pick_up_branch_office: customers.pick_up_branch_office,
            p_id_branch_office: customers.id_branch_office,
            p_details: dets,
            p_total: parseFloat(getSubtotal().total),
            p_has_shipping: getSubtotal().has_shipping,
            p_is_usa: getSubtotal().is_usa,
            p_tax_value: getSubtotal().tax_value,
            p_rfc_customers: invoiceData.p_rfc_customers,
            p_zip_code_customers: invoiceData.p_zip_code_customers,
            p_id_regimen: invoiceData.p_id_regimen,
            p_id_cfdi: invoiceData.p_id_cfdi,
            p_has_invoice_doc: hasInvoice ? 1 : 0,
            p_has_discount: discount.status ? 1 : 0,
            p_discount_type: discount.status ? discount.discount_type : '',
            p_discount_amount: discount.status ? discount.discount : 0,
            p_has_subscription: hasSubscription ? 1 : 0
        }
    }, [details, customers, getSubtotal, invoiceData, hasInvoice, discount, hasSubscription])

    const cboBranchOffice = useMemo(() => {
        if (!customers.id_branch_office) {
            return
        }

        let finded = rowsBranchOffice.find(t => parseInt(t.id_branch_office) === parseInt(customers.id_branch_office))

        if (!finded) {
            return
        }

        return {
            label: finded.name_branch_office,
            value: finded.id_branch_office
        }
    }, [customers.id_branch_office, rowsBranchOffice])

    const cboRegimen = useMemo(() => {
        if (!invoiceData.p_id_regimen) {
            return ''
        }

        let finded = regimen.find(t => parseInt(invoiceData.p_id_regimen) === parseInt(t.id_regimen))

        if (!finded) {
            return ''
        }
        return {
            label: `${finded.id_regimen} - ${finded.name_regimen}`,
            value: finded.id_regimen
        }
    }, [invoiceData.p_id_regimen, regimen])

    const cboCfdi = useMemo(() => {
        if (!invoiceData.p_id_cfdi) {
            return ''
        }

        let finded = cfdi.find(t => (invoiceData.p_id_cfdi) === (t.id_cfdi))

        if (!finded) {
            return ''
        }
        return {
            label: `${finded.id_cfdi} - ${finded.name_cfdi}`,
            value: finded.id_cfdi
        }
    }, [invoiceData.p_id_cfdi, cfdi])

    return <>
        {ready && type === 'error-pago' ? <div className="alert alert-danger">
            El pago fue cancelado. Por favor, vuelva a intentar
        </div> : ''}
        {ready && !existsTax ? <div className="alert alert-warning">
            No existe TAX/IVA para la venta. Comunicarse con Área responsable.
        </div> : ''}
        <Card className="mb-4">
            <Card.Header className="justify-content-between">
                <span className="align-self-center">Mi Carrito de Compras</span>
                <Button size="sm" variant="secondary" onClick={_ => history.push(Helpers.config.convertUrl({ url: '/ecommerce' }))}>
                    <i className="fa fa-shopping-cart text-white cur-pointer"></i> Seguir Comprando
                </Button>
            </Card.Header>
        </Card>
        <Card className="mb-4">
            <Card.Header>
                Información de Cliente
            </Card.Header>
            <Card.Body>
                <ReactPlaceholder rows={5} showLoadingAnimation ready={ready}>
                    <div className="form-row">
                        <Input
                            text="Nombre de Cliente"
                            defaultValue={customers.full_name_customers}
                            classNameParent="col-6"
                            disabled
                        />
                        <Input
                            text="Dirección"
                            defaultValue={customers.address_customers}
                            classNameParent="col-6 mb-2"
                            disabled
                        />
                        <SwitchToggle
                            classNameParent="col-12 mb-2"
                            id="checkbox_pick_up_branch_office"
                            checked={parseInt(customers.pick_up_branch_office) === 1}
                            textCheck="¿Recoger en Sucursal?"
                            textUnChecked="¿Recoger en Sucursal?"
                            onChange={e => {
                                setCustomers({ ...customers, pick_up_branch_office: e.currentTarget.checked ? 1 : 0, id_branch_office: '' })

                                if (e.currentTarget.checked) {
                                    setHasTaxByZipCode(false);
                                    setTaxValue(0);
                                } else {
                                    if (!isNaN(parseFloat(taxZipCode?.tax_value))) {
                                        setTaxValue(parseFloat(taxZipCode?.tax_value));
                                        setHasTaxByZipCode(true);
                                    }
                                }
                            }}
                            disabled={!preview}
                        />
                        {parseInt(customers.pick_up_branch_office) === 1 && <Select
                            text="Sucursal"
                            options={rowsBranchOffice.map(b => {
                                return {
                                    label: b.name_branch_office,
                                    value: b.id_branch_office
                                }
                            })}
                            value={cboBranchOffice}
                            onChange={e => {
                                Controllers.branch_office.get_branch_office_tax_shipping({
                                    p_id_branch_office: e.value,
                                }).then(res => {
                                    setCustomers({ ...customers, id_branch_office: e.value })
                                    setTaxValue(parseFloat(res.data.value_tax))
                                })
                            }}
                            classNameParent="col-12 mb-2"
                            disabled={!preview}
                        />}
                        <SwitchToggle
                            id="chk-has-invoice"
                            checked={hasInvoice}
                            textCheck="¿Tiene Factura?"
                            textUnChecked="¿Tiene Factura?"
                            onChange={e => {
                                setHasInvoice(e.currentTarget.checked)
                            }}
                            disabled={!preview}
                        />
                        {hasInvoice && !isUSA && <>
                            <Input
                                text="RFC"
                                placeholder="RFC"
                                classNameParent="col-12 col-md-6 mt-2"
                                icon="fas fa-sort-numeric-up-alt"
                                className="text-center"
                                value={invoiceData.p_rfc_customers}
                                required
                                onChange={e => {
                                    setInvoiceData({ ...invoiceData, p_rfc_customers: e.currentTarget.value })
                                }}
                                disabled={!preview}
                            />
                            <Input
                                text="Código Postal"
                                placeholder="Código Postal"
                                classNameParent="col-12 col-md-6 mt-2"
                                icon="fas fa-sort-numeric-up-alt"
                                className="text-center"
                                value={invoiceData.p_zip_code_customers}
                                required
                                onChange={e => {
                                    setInvoiceData({ ...invoiceData, p_zip_code_customers: e.currentTarget.value })
                                }}
                                disabled={!preview}
                            />
                            <Select
                                classNameParent="col-12 col-md-6 mt-2"
                                icon="far fa-building"
                                text="Uso de CFDI"
                                options={cfdi.map(t => {
                                    return {
                                        label: `${t.id_cfdi} - ${t.name_cfdi}`,
                                        value: t.id_cfdi
                                    }
                                })}
                                value={cboCfdi}
                                onChange={e => {
                                    setInvoiceData({ ...invoiceData, p_id_cfdi: e.value, p_id_regimen: '' })
                                }}
                                disabled={!preview}
                            />
                            <Select
                                classNameParent="col-12 col-md-6 mt-2"
                                icon="far fa-building"
                                text="Régimen Fiscal"
                                options={regimen.filter(r => {
                                    if (!invoiceData.p_id_cfdi) {
                                        return false
                                    }

                                    const cfdiAux = cfdi.find(t => t.id_cfdi === invoiceData.p_id_cfdi)

                                    if (!cfdiAux) {
                                        return false
                                    }

                                    return cfdiAux.regimen_ids.includes(r.id_regimen)
                                }).map(t => {
                                    return {
                                        label: `${t.id_regimen} - ${t.name_regimen}`,
                                        value: t.id_regimen
                                    }
                                })}
                                value={cboRegimen}
                                onChange={e => {
                                    setInvoiceData({ ...invoiceData, p_id_regimen: e.value })
                                }}
                                disabled={!preview}
                            />
                        </>}
                        <SwitchToggle
                            classNameParent={'mt-3'}
                            id="chk-has-subscription"
                            checked={hasSubscription}
                            textCheck="¿Desea que esta compra se realice automáticamente cada mes?"
                            textUnChecked="¿Desea que esta compra se realice automáticamente cada mes?"
                            onChange={e => {
                                setHasSubscription(e.currentTarget.checked)
                            }}
                            disabled={!preview}
                        />
                    </div>
                </ReactPlaceholder>
            </Card.Body>
        </Card>
        <Card className="mb-4">
            <Card.Header>
                <div>Listado de Productos</div>
                {discount.status && <div className='d-flex justify-content-center'>
                    {discount.status && <div className='ml-2 badge badge-success align-self-center'>
                        Descuento {discount.discount * 100}%
                    </div>}
                </div>}
            </Card.Header>
            <Card.Body>
                {ready && existsStock?.products?.length > 0 ? <div className="alert alert-warning d-flex flex-column">
                    <span>{existsStock.message}</span>
                    <span className="mt-2 mb-2">Detalle</span>

                    {React.Children.toArray(existsStock.products.map(p => <>
                        <span>Producto: <strong>{p.key_product}</strong></span>
                        <span>Cantidad Solicitada: <strong>{p.qty_request}</strong></span>
                        <span>Stock: <strong>{p.qty}</strong></span>
                    </>))}
                </div> : ''}
                <FormCustom onSubmit={_ => {
                    if (parseInt(customers.pick_up_branch_office) === 1) {
                        if (isNaN(parseInt(customers.id_branch_office))) {
                            Helpers.toast.construct({
                                response: 'warning', message: 'Seleccionar sucursal de recojo', toast
                            })
                            return
                        }
                    }

                    if (hasInvoice && !isUSA && !invoiceData.p_id_cfdi) {
                        Helpers.toast.construct({
                            response: 'warning',
                            message: 'Seleccione un uso de CFDI.',
                            toast
                        })
                        return;
                    }

                    if (hasInvoice && !isUSA && !invoiceData.p_id_regimen) {
                        Helpers.toast.construct({
                            response: 'warning',
                            message: 'Seleccione un régimen.',
                            toast
                        })
                        return;
                    }

                    setShowLoading(true)
                    Controllers.cart.cart_det_mass_insert_update(dataSubmit()).then(res => {
                        if (res.response !== 'success') {
                            setExistsStock({
                                message: res.message,
                                products: res.data
                            })
                            Helpers.toast.construct({
                                ...res, toast
                            })
                            setPreview(true)
                            return
                        }
                        setExistsStock({
                            message: '',
                            products: []
                        })
                        setReady(false)
                        setPreview(false)
                        loadAll();
                    }).catch(_ => {
                        window.location.reload()
                    })
                        .finally(_ => setShowLoading(false))
                }} viewSubmit={false}>
                    <div className="table-responsive">
                        <ReactPlaceholder rows={10} showLoadingAnimation ready={ready}>
                            <table className="table table-sm table-hover table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>Descripción</th>
                                        <th>Cantidad</th>
                                        <th>Precio</th>
                                        <th>Puntos</th>
                                        <th>Valor Negocio</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {React.Children.toArray(details.map(r => <tr>
                                        <td>{r.description_store_product}</td>
                                        <td className="text-center">
                                            {preview ? <Input
                                                className="text-center"
                                                required
                                                type="number"
                                                min="1"
                                                /* max={r.exists_current_qty_product} */
                                                /* invalid={'Stock: ' + r.exists_current_qty_product} */
                                                step="1"
                                                value={!isNaN(parseInt(r.qty_product)) ? r.qty_product : ''}
                                                onChange={e => {
                                                    setDetails(details.map(rr => {
                                                        if (parseInt(r.id_product) === parseInt(rr.id_product)) {
                                                            rr.qty_product = e.currentTarget.value
                                                        }
                                                        return rr
                                                    }))
                                                    setExistsStock({
                                                        message: '',
                                                        products: []
                                                    })
                                                }}
                                                style={{
                                                    minWidth: '100px'
                                                }}
                                            /> : !isNaN(parseInt(r.qty_product)) ? r.qty_product : ''}
                                        </td>
                                        <td className="text-center">
                                            {parseFloat(r.price_product).toFixed(2)}
                                        </td>
                                        <td className="text-center">
                                            {parseFloat(r.point_product).toFixed(2)}
                                        </td>
                                        <td className="text-center">
                                            {parseFloat(r.value_business_product).toFixed(2)}
                                        </td>
                                        <td>
                                            {preview ? <Button size="xs" variant="danger" onClick={() => {
                                                setExistsStock({
                                                    message: '',
                                                    products: []
                                                })
                                                setDetails(details.filter(rr => parseInt(rr.id_product) !== parseInt(r.id_product)))
                                            }}>
                                                <i className="fa fa-trash"></i>
                                            </Button> : ''}
                                        </td>
                                    </tr>))}
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td align="center">Costo de envío</td>
                                        <td align="center">{getSubtotal().shipping} {customers.code_money}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td align="center">Subtotal</td>
                                        <td align="center">{getSubtotal().subtotal} {customers.code_money}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td align="center">IVA/TAX{hasTaxByZipCode ? '*' : ''} ({parseFloat(taxValue * 100).toFixed(2)}%)</td>
                                        <td align="center">{getSubtotal().iva} {customers.code_money}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td align="center">Total</td>
                                        <td align="center"><strong>{getSubtotal().totalIva} {customers.code_money}</strong></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td align="center">Total sin IVA</td>
                                        <td align="center"><strong>{getSubtotal().totalWithoutIva} {customers.code_money}</strong></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td align="center">Total General</td>
                                        <td align="center"><strong>{getSubtotal().total} {customers.code_money}</strong></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>

                            {details.length === 0 || !existsTax ? '' : (
                                preview ? <Button type="submit" variant="info" block>
                                    <i className="fa fa-dollar-sign"></i> {hasSubscription ? 'Pagar ahora y suscribirme' : 'Pagar Ahora'}
                                </Button> : <>
                                    {customers.code_money === 'MXN' ? <>
                                        <Button type="button" variant="info" block onClick={_ => {
                                            setShowLoading(true)
                                            Controllers.cart.mercadopago_cart().then(res => {
                                                if (res.response !== 'success') {
                                                    Helpers.toast.construct({ ...res, toast })
                                                    setShowLoading(false)
                                                    return
                                                }
                                                setShowLoading(false)
                                                window.location.href = res.data.link_pay
                                            }).catch(() => {
                                                setShowLoading(false)
                                            })
                                        }}>
                                            Pagar con Mercado Pago
                                        </Button>
                                        <Button type="button" variant="danger" block onClick={_ => {
                                            setShowLoading(true)
                                            Controllers.cart.pagos_online_cart().then(res => {
                                                if (res.response !== 'success') {
                                                    Helpers.toast.construct({ ...res, toast })
                                                    setShowLoading(false)
                                                    return
                                                }
                                                setShowLoading(false)
                                                window.location.href = res.data.link_pay
                                            }).catch(() => {
                                                setShowLoading(false)
                                            })
                                        }}>
                                            Pagar con Santander
                                        </Button>
                                    </>
                                        : <>
                                            <Button type="button" variant="square" block onClick={_ => {
                                                setShowLoading(true)
                                                Controllers.cart.square_cart().then(res => {
                                                    if (res.response !== 'success') {
                                                        Helpers.toast.construct({ ...res, toast })
                                                        setShowLoading(false)
                                                        return
                                                    }
                                                    setShowLoading(false)
                                                    window.location.href = res.data.link_pay
                                                }).catch(() => {
                                                    setShowLoading(false)
                                                })
                                            }}>
                                                <i className="fab fa-money"></i> Pagar con Square
                                            </Button>
                                            <Button type="button" variant="paypal" block onClick={_ => {
                                                setShowLoading(true)
                                                Controllers.cart.paypal_cart().then(res => {
                                                    if (res.response !== 'success') {
                                                        Helpers.toast.construct({ ...res, toast })
                                                        setShowLoading(false)
                                                        return
                                                    }
                                                    setShowLoading(false)
                                                    window.location.href = res.data.link_pay
                                                }).catch(() => {
                                                    setShowLoading(false)
                                                })
                                            }}>
                                                <i className="fab fa-paypal"></i> Pagar con Paypal
                                            </Button>
                                        </>}
                                    <Button type="button" variant="secondary" block onClick={_ => setPreview(true)}>
                                        <i className="fa fa-times"></i> Cancelar
                                    </Button>
                                </>
                            )}

                            {ready && hasTaxByZipCode && <div className='mt-2 d-flex flex-column'>
                                <small>* El TAX se calcula en base al código postal de envío.</small>
                                <small>Código postal: {taxZipCode.zip_code}</small>
                                <small>Región: {taxZipCode.tax_region_name}</small>
                                <small>Estado: {taxZipCode.state}</small>
                            </div>}
                        </ReactPlaceholder>
                    </div>
                </FormCustom>
            </Card.Body>
        </Card>
        <Loading show={showLoading}>
            <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
        </Loading>
        <div id="formPaypalContent"></div>
    </>
}

export default Cart